// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-button[data-v-533838bb]{width:100%}.disabled[data-v-533838bb]{cursor:not-allowed}.disabled img[data-v-533838bb]{opacity:.5}.link[data-v-533838bb]{color:red;text-decoration:underline}.link-message[data-v-533838bb]{font-size:1.2rem}@media screen and (min-width:560px){.link-message[data-v-533838bb]{font-size:1rem}}@media screen and (min-width:960px){.link-message[data-v-533838bb]{font-size:1rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
